import React, { useState } from "react";
import { Select, MenuItem, Typography, Box } from "@mui/material";
import useStore from "../../helpers/useStore";
import { UserContext } from "../../stores/User/User.provider";
import { observer } from "mobx-react";
import { useLocations, useCurrentLocation } from "../../stores/User/user.queries";

interface LocationSelectorProps {
  style?: React.CSSProperties;
}

const LocationSelector = observer(({ style }: LocationSelectorProps) => {
  const { user, hasPermission, changeUserLocation } = useStore(UserContext);
  const { data: locations } = useLocations();
  const currentLocation = useCurrentLocation();

  const handleChange = async (event: any) => {
    const newValue = event.target.value;
    // console.log("newValue", newValue);

    // Call your API with the new value
    try {
      await changeUserLocation(newValue);
    } catch (error) {
      console.error("Error updating location:", error);
    }
  };

  if (!user) {
    return null;
  }

  return (
    <Box sx={{ display: { xs: "none", md: "flex" }, paddingRight: 2, ...style }}>
      {hasPermission("changeLocation") ? (
        <Select
          value={user?.locationId}
          label="Location"
          sx={{ color: "white" }}
          onChange={handleChange}
        >
          {locations?.map((location: any) => (
            <MenuItem key={location.id} value={location.id}>
              {location.name}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Typography sx={{ color: "white" }}>{currentLocation?.name}</Typography>
      )}
    </Box>
  );
});

export default LocationSelector;
